import { memo } from 'react';
import { LeaveFamilyTemplate } from 'components/templates/LeaveFamilyTemplate';

type Props = {};

export const LeaveFamily = memo((_props: Props) => {
	return <LeaveFamilyTemplate />;
});
